import { INVALID_DATE } from 'config/constants'
import { PeriodDate } from 'models/dates'

export const periodDateHandler = ({ to, from }: PeriodDate): PeriodDate => {
  return { from, to: to === INVALID_DATE ? '' : to }
}
